const COMEET_TOKEN = '62188018812631018862C4188';
const COMEET_COMPANY_ID = '60.002';
const COMEET_FILE_NAME = 'api.js';
const COMEET_URL = 'https://www.comeet.co/careers-api';
const COMMIT_API_URL = `${COMEET_URL}/2.0/company/${COMEET_COMPANY_ID}/positions?details=true&token=${COMEET_TOKEN}`;

const DEPARTMENT_KEYS = {
    Technology: 'rnd',
    Product: 'product',
    BI: 'bi',
    Design: 'design',
    Marketing: 'corporate_marketing',
    'Marketplace Business Operations': 'marketplace_business_ops',
    'Customer Journey': 'customer_support',
    'G&A': 'gna',
    Finance: 'finance',
    Sales: 'sales',
    IT: 'it',
};

const LOCATION_KEYS = {
    'Tel Aviv-Yafo': 'tlv',
    'New York': 'nyc',
    'San Francisco': 'sf',
    Orlando: 'orl',
    London: 'lon',
    Berlin: 'ber',
    Kyiv: 'kyiv',
    Phoenix: 'pho',
    'New Jersey': 'nj',
    Sydney: 'syd',
    'Poland Remote': 'pr',
    'Australia Remote': 'ar',
    'Germany Remote': 'gr',
    'US Remote': 'usr',
    Remote: 'rmt',
};

const MAIN_PAGE_PATH = '/jobs';
const COMPANY_NAME = 'Fiverr';
const COMPANY_COLOR = '#1DBF73'; // Green 700
const COMPANY_FONT_SIZE = '16px';

export {
    COMEET_TOKEN,
    COMEET_COMPANY_ID,
    COMEET_FILE_NAME,
    COMEET_URL,
    COMMIT_API_URL,
    DEPARTMENT_KEYS,
    LOCATION_KEYS,
    MAIN_PAGE_PATH,
    COMPANY_NAME,
    COMPANY_COLOR,
    COMPANY_FONT_SIZE,
};
